import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Col from 'reactstrap/lib/Col';
import { formatPriceStringV2 } from 'site-modules/shared/utils/price-utils';
import { Row } from 'reactstrap';
import { DealPopover } from 'site-modules/shared/components/deal/deal-popover/deal-popover';
import { DealType } from 'site-modules/shared/components/deal/deal-type/deal-type';
import { ScrollLink } from 'site-modules/shared/components/scroll-link/scroll-link';
import { scroller } from 'react-scroll';
import { PAYMENT_CALCULATOR_NAME } from 'site-modules/shared/constants/calculator/calculator';
import { ENTER_KEY_VALUE } from 'site-modules/shared/constants/key-values';
import { isUsed } from 'site-modules/shared/utils/inventory-utils/is-used';
import { getEspTrustDate } from 'site-modules/shared/utils/esp';
import { EventToolbox } from 'client/utils/event-toolbox';
import { TrackingConstant } from 'client/tracking/constant';
import { CALCULATOR_EVENTS } from 'client/site-modules/shared/constants/calculator/events';
import { getSavingsText } from 'client/site-modules/shared/utils/inventory-utils/get-savings-text';
import { DealerPrice } from 'site-modules/inventory/components/price-summary/dealer-price';
import { DealerMsrpPrice } from 'site-modules/inventory/components/price-summary/dealer-msrp-price/dealer-msrp-price';
import { isNew } from 'site-modules/shared/utils/inventory-utils/is-new';
import { isPrivateParty } from 'site-modules/shared/utils/dealer-details-utils';
import { LoadingDots } from 'client/site-modules/shared/components/loading-dots/loading-dots';
import { InfoTooltip } from 'site-modules/shared/components/inventory/info-tooltip/info-tooltip';
import { getDealerFeesLinkText } from 'site-modules/shared/utils/inventory/vdp-utils';
import { DealerFeesModal } from 'site-modules/shared/components/inventory/dealer-fees-modal/dealer-fees-modal';
import { DealerFeesPriceDetails } from 'site-modules/shared/components/inventory/dealer-fees-price-details/dealer-fees-price-details';

import './price-row.scss';

const SCROLL_CONFIG = {
  duration: 300,
  offset: -105,
  smooth: true,
  spy: true,
};

const SCROLL_CONFIG_MOBILE = {
  duration: 300,
  offset: -145,
  smooth: true,
  spy: true,
};

export class PriceRow extends Component {
  static propTypes = {
    msrpPrice: PropTypes.number,
    advertisedPrice: PropTypes.number,
    isDealerMsrpAdvertisedPriceSource: PropTypes.bool,
    savings: PropTypes.number,
    hasBestPrice: PropTypes.bool,
    bestDealPrice: PropTypes.number,
    dealType: PropTypes.string,
    stateCode: PropTypes.string,
    type: PropTypes.string,
    monthlyPaymentValue: PropTypes.number,
    monthlyPaymentLabel: PropTypes.string,
    isLoading: PropTypes.bool,
    priceStrikethrough: PropTypes.bool,
    showDealType: PropTypes.bool,
    isMobile: PropTypes.bool,
    displayLeasePayment: PropTypes.bool,
    forceLease: PropTypes.bool,
    dataTrackingParent: PropTypes.string,
    isBasicViewEnabled: PropTypes.bool,
    isVlaPage: PropTypes.bool,
    isHighESP: PropTypes.bool,
    isVdpPriceCheckerEnabled: PropTypes.bool,
    showDealerPriceAndHighESP: PropTypes.bool,
    totalRebate: PropTypes.number,
    transactionCountCopyValues: PropTypes.shape({
      group: PropTypes.string,
      level: PropTypes.string,
    }),
    hideMonthlyPayment: PropTypes.bool,
    isMsrpFeesIncluded: PropTypes.bool,
    isDealerFeesEnabled: PropTypes.bool,
    isPartner: PropTypes.bool,
    vinData: PropTypes.shape({}),
    isDisplayBelowAboveMarketCopy: PropTypes.bool,
    isLeaseView: PropTypes.bool,
  };

  static defaultProps = {
    msrpPrice: 0,
    advertisedPrice: 0,
    isDealerMsrpAdvertisedPriceSource: false,
    savings: 0,
    hasBestPrice: false,
    bestDealPrice: 0,
    dealType: '',
    stateCode: '',
    type: '',
    monthlyPaymentValue: 0,
    monthlyPaymentLabel: '',
    isLoading: false,
    priceStrikethrough: false,
    showDealType: false,
    isMobile: false,
    displayLeasePayment: false,
    forceLease: false,
    dataTrackingParent: '',
    isBasicViewEnabled: false,
    isVlaPage: false,
    isHighESP: false,
    isVdpPriceCheckerEnabled: false,
    showDealerPriceAndHighESP: false,
    totalRebate: null,
    transactionCountCopyValues: null,
    hideMonthlyPayment: false,
    isMsrpFeesIncluded: false,
    isDealerFeesEnabled: false,
    isPartner: false,
    vinData: {},
    isDisplayBelowAboveMarketCopy: false,
    isLeaseView: false,
  };

  state = { isDealerFeesModalOpen: false };

  shouldComponentUpdate(nextProps) {
    const { displayLeasePayment, isLoading } = nextProps;

    return displayLeasePayment ? !isLoading : true;
  }

  onESPTooltipOpen = () => {
    EventToolbox.fireTrackAction({
      event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
      event_data: {
        action_name: TrackingConstant.ACTION_VIEW_CONTENT,
        subaction_name: TrackingConstant.ACTION_VIEW_CONTENT,
        action_category: TrackingConstant.USER_ACTION_CATEGORY,
        action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
        creative_id: this.props.dataTrackingParent,
        value: 'Edmunds suggests you pay',
      },
    });
  };

  onTooltipOpen = value => {
    EventToolbox.fireTrackAction({
      event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
      event_data: {
        action_name: TrackingConstant.ACTION_VIEW_CONTENT,
        subaction_name: TrackingConstant.ACTION_VIEW_CONTENT,
        action_category: TrackingConstant.USER_ACTION_CATEGORY,
        action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
        creative_id: this.props.dataTrackingParent,
        value,
      },
    });
  };

  onMonthlyClick = () => {
    EventToolbox.fireCustomEvent(CALCULATOR_EVENTS.EXPAND_CALCULATOR);
  };

  handleKeyPress = ({ key }) => {
    if (key === ENTER_KEY_VALUE) {
      scroller.scrollTo(PAYMENT_CALCULATOR_NAME, this.props.isMobile ? SCROLL_CONFIG_MOBILE : SCROLL_CONFIG);

      if (this.props.isBasicViewEnabled) {
        EventToolbox.fireCustomEvent(CALCULATOR_EVENTS.EXPAND_CALCULATOR);
      }
    }
  };

  handleDealerFeesClick = () => {
    this.setState({ isDealerFeesModalOpen: true });
  };

  handleDealerFeesModalToggle = () => {
    this.setState({ isDealerFeesModalOpen: false });
  };

  renderDealerFeesPriceDetails = () => {
    const { vinData, isLeaseView } = this.props;
    return <DealerFeesPriceDetails vinData={vinData} innerClassName="px-1 py-0_5" isLeaseView={isLeaseView} />;
  };

  renderDealerFeesLink() {
    const { isDealerFeesEnabled, vinData } = this.props;
    if (!isDealerFeesEnabled) return null;

    const dealerFeesLinkText = getDealerFeesLinkText(vinData);

    if (!dealerFeesLinkText || isPrivateParty(vinData)) {
      return null;
    }

    return (
      <>
        <button
          type="button"
          className="btn btn-link p-0 text-dark size-14 text-decoration-underline text-transform-none fw-normal"
          onClick={this.handleDealerFeesClick}
          data-tracking-id="vdp_dealer_fees_button_click"
          data-tracking-value={dealerFeesLinkText}
        >
          {dealerFeesLinkText}
        </button>
        <DealerFeesModal
          renderContent={this.renderDealerFeesPriceDetails}
          isOpen={this.state.isDealerFeesModalOpen}
          toggle={this.handleDealerFeesModalToggle}
        />
      </>
    );
  }

  render() {
    const {
      msrpPrice,
      advertisedPrice,
      isDealerMsrpAdvertisedPriceSource,
      savings,
      hasBestPrice,
      bestDealPrice,
      dealType,
      stateCode,
      type,
      monthlyPaymentValue,
      monthlyPaymentLabel,
      isLoading,
      priceStrikethrough,
      showDealType,
      isMobile,
      displayLeasePayment,
      forceLease,
      isBasicViewEnabled,
      isVlaPage,
      isHighESP,
      isVdpPriceCheckerEnabled,
      showDealerPriceAndHighESP,
      totalRebate,
      transactionCountCopyValues,
      hideMonthlyPayment,
      isMsrpFeesIncluded,
      isDisplayBelowAboveMarketCopy,
    } = this.props;
    const isUsedType = isUsed(type);
    const isNewType = isNew(type);
    const { group, level } = transactionCountCopyValues;
    const popover = (
      <div className={classNames('d-inline-block', { 'mb-0_25': !isDisplayBelowAboveMarketCopy })}>
        <DealPopover
          trackingId="vin_show_content"
          type={dealType}
          savings={savings}
          stateCode={stateCode}
          condition={type}
          isSavingsPresent={isDisplayBelowAboveMarketCopy}
          isDisplayMarketInfo={isUsedType}
          tooltipClasses=""
        />
      </div>
    );
    const monthlyPayment = monthlyPaymentValue && `${formatPriceStringV2(monthlyPaymentValue)}/mo`;
    const monthlyPaymentContent = !hideMonthlyPayment && (
      <div
        className={classNames('medium text-nowrap text-gray-darker', {
          'monthly-payment': !isBasicViewEnabled && !hasBestPrice && showDealType && isDisplayBelowAboveMarketCopy,
        })}
      >
        {displayLeasePayment ? (
          <span className="text-underline">customize</span>
        ) : (
          <Fragment>
            {monthlyPaymentLabel}:{' '}
            <span className={classNames({ 'text-underline': !isVlaPage, 'd-none': isLoading })}>{monthlyPayment}</span>
          </Fragment>
        )}
      </div>
    );
    const monthlyPaymentLink = isVlaPage ? (
      monthlyPaymentContent
    ) : (
      <ScrollLink
        to={PAYMENT_CALCULATOR_NAME}
        onKeyPress={this.handleKeyPress}
        tabIndex={0}
        data-tracking-id="view_content_estimate"
        data-tracking-value={monthlyPayment}
        className={classNames('d-block text-gray-dark', { invisible: !monthlyPayment })}
        onClick={isBasicViewEnabled ? this.onMonthlyClick : null}
        scrollConfig={isMobile ? SCROLL_CONFIG_MOBILE : SCROLL_CONFIG}
        aria-label={`est. loan: ${monthlyPayment} - See estimate loan details on the payment calculator`}
      >
        {monthlyPaymentContent}
      </ScrollLink>
    );
    const includingIncentives = isNewType && totalRebate ? ', with incentives applied,' : '';
    const dealerFeesLink = this.renderDealerFeesLink();
    const shouldRenderMonthlyPaymentBelowPrice = !hasBestPrice && !displayLeasePayment;
    const shouldRenderNewBestPriceLayout = hasBestPrice && isNewType && !forceLease && !displayLeasePayment;
    const espTooltip = hasBestPrice && (
      <Fragment>
        {(bestDealPrice >= msrpPrice || showDealerPriceAndHighESP) && (
          <div className="fw-bold">High demand is causing the market average price paid to be above MSRP.</div>
        )}
        {isHighESP
          ? `This is the price that others are paying${includingIncentives} based on ${group} sales in ${level} up through ${getEspTrustDate()}.`
          : `This is the price Edmunds' suggests you pay${
              totalRebate ? ', with incentives applied,' : ''
            } based on ${group} sales in ${level} up through ${getEspTrustDate()}.`}
      </Fragment>
    );
    const leasePaymentCol = (
      <Col xs={6}>
        <div className="mb-0 fw-normal text-nowrap small">{monthlyPaymentLabel}</div>
        <div className="pos-r">
          {!!monthlyPaymentValue && (
            <Fragment>
              <div className={classNames('loading-section pos-a', { fadeOut: !isLoading })}>
                <LoadingDots className="py-0_75" />
                <div className="text-nowrap size-16 text-cool-gray-30">Checking the latest rates</div>
              </div>
              <div className={classNames('loaded-section', { fadeIn: !isLoading })} style={{ opacity: 0 }}>
                <span>
                  <span className="heading-2">{formatPriceStringV2(monthlyPaymentValue)}</span>
                  /mo
                </span>
                <span>{monthlyPaymentLink}</span>
              </div>
            </Fragment>
          )}
        </div>
      </Col>
    );

    const bestPriceCol = hasBestPrice && (
      <Col xs={6} className={classNames({ 'text-end': shouldRenderNewBestPriceLayout })}>
        <div className="mb-0 fw-normal text-nowrap small text-primary-darker">
          {isHighESP ? 'What others are paying' : 'Edmunds suggests you pay'}
          {!isUsedType && (
            <InfoTooltip
              id="esp-tooltip"
              className="top-0 esp-tooltip"
              item={{
                text: espTooltip,
                placement: 'bottom',
              }}
              onTooltipOpen={this.onESPTooltipOpen}
              screenReaderTooltipLabel={isHighESP ? 'what others are paying' : 'edmunds suggests you pay'}
            />
          )}
        </div>
        <div
          className={
            shouldRenderNewBestPriceLayout
              ? 'price-summary-esp-price mb-0 fw-normal text-cool-gray-30'
              : 'heading-2 mb-0'
          }
        >
          <span>{formatPriceStringV2(bestDealPrice)}</span>
        </div>
        {monthlyPaymentLink}
      </Col>
    );

    const dealerPriceCol = (
      <Col
        xs={6}
        style={{
          textAlign: hasBestPrice && bestDealPrice && !shouldRenderNewBestPriceLayout ? 'right' : 'initial',
        }}
      >
        {isUsedType ? (
          <DealerPrice dealerPrice={advertisedPrice} />
        ) : (
          <DealerMsrpPrice
            advertisedPrice={advertisedPrice}
            isDealerMsrpAdvertisedPriceSource={isDealerMsrpAdvertisedPriceSource}
            onTooltipOpen={this.onTooltipOpen}
            priceStrikethrough={priceStrikethrough}
            isMsrpFeesIncluded={isMsrpFeesIncluded}
          />
        )}
        {shouldRenderMonthlyPaymentBelowPrice ? (
          <>
            {dealerFeesLink}
            {monthlyPaymentLink}
          </>
        ) : (
          dealerFeesLink
        )}
      </Col>
    );

    return (
      <Row className="price-summary-section align-items-start" data-test="price-summary-col">
        {displayLeasePayment && leasePaymentCol}
        {shouldRenderNewBestPriceLayout ? (
          <Fragment>
            {dealerPriceCol}
            {bestPriceCol}
          </Fragment>
        ) : (
          <Fragment>
            {!displayLeasePayment && bestPriceCol}
            {dealerPriceCol}
          </Fragment>
        )}
        {!hasBestPrice && showDealType && (
          <Col xs={6} className="text-end mt-0_5">
            <DealType
              type={dealType}
              isCentered={false}
              className={classNames('justify-content-end align-items-center mb-0_25', {
                'd-inline-block': isDisplayBelowAboveMarketCopy,
              })}
              labelClasses="heading-4 pb-0_25"
              isDealImgEnabled
              isLabelAligned={false}
              isAnchorLink={isVdpPriceCheckerEnabled}
              iconClassName="me-1 size-20"
              wrapperStyle={{ fontSize: '1.25rem', lineHeight: '1.5rem', paddingBottom: '4px' }}
              iconStyle={{ fontSize: '1.25rem', letterSpacing: 0, lineHeight: '1.5rem' }}
            >
              {!isDisplayBelowAboveMarketCopy && popover}
            </DealType>
            {isDisplayBelowAboveMarketCopy && (
              <div className="mb-0 fw-normal text-gray-dark heading-5">
                <div className="align-self-end label text-nowrap text-info text-gray-darker text-lowercase">
                  {getSavingsText(savings)}
                  {popover}
                </div>
              </div>
            )}
          </Col>
        )}
      </Row>
    );
  }
}
